/**
 * routes.js menüsünden rol yetkileri için sayfa listesi üretir.
 * - Menüde adı olmayan sayfalar (ör. connect-mbl) key'den okunabilir bir ad alır (boş satır olmasın)
 * - Aynı adı taşıyan sayfalar (Road/Ocean/Air altındaki "Create Shipment" gibi) bağlı oldukları
 *   menüyle ayrılır; aksi halde listede ayırt edilemiyor ve aynı key ile çiziliyordu
 */
const humanize = (s) =>
    String(s || "")
        .replace(/^\//, "")
        .split(/[-_/]+/)
        .filter(Boolean)
        .map((w) => (w.length <= 4 && /^(mbl|ombl|ambl|hfl|rfq|tms|pos)$/i.test(w) ? w.toUpperCase() : w.charAt(0).toUpperCase() + w.slice(1)))
        .join(" ");

export const buildPageOptions = (routeList) => {
    const opts = [];
    const traverse = (items, parentName) => {
        items.forEach((item) => {
            if (item.route) {
                opts.push({
                    label: item.name || humanize(item.key || item.route),
                    value: item.route,
                    parent: parentName || "",
                });
            }
            if (item.collapse) traverse(item.collapse, item.name || parentName);
        });
    };
    traverse(routeList);

    const counts = opts.reduce((acc, o) => ({ ...acc, [o.label]: (acc[o.label] || 0) + 1 }), {});
    const seen = new Set();
    return opts
        .map((o) => ({
            label: counts[o.label] > 1 && o.parent ? `${o.label} (${o.parent})` : o.label,
            value: o.value,
        }))
        // aynı rota birden fazla kez tanımlıysa tek seçenek olsun
        .filter((o) => (seen.has(o.value) ? false : seen.add(o.value)));
};

// src/constants/pages.js
export const pagesOptions = [
    { label: "Dashboard", value: "/dashboard" },
    { label: "Role Management", value: "/role-management" },
    { label: "Shipments", value: "/shipments" },
    { label: "Users", value: "/users" },
    { label: "Reports", value: "/reports" },
    // … uygulamanızdaki diğer sayfalar
];
